<template>
    <section class="room__rm-files rm-files">
        <h2 class="rm-files__title r-title">Отчёт по консультации</h2>
        <report></report>
        <report-manage></report-manage>
    </section>
</template>

<script>

    import Report from './Report';
    import ReportManage from './ReportManage';

    export default {
        name: 'ReportScreen',
        components: {
            Report,
            ReportManage,
        }
    }
</script>
